<div class="profile-menu-credits wallet-card-shimmer" aria-busy="true" aria-label="Loading credits">
    <div class="flex-centered-container gap-8-px mat-icon-16 margin-8-bottom wallet-card-shimmer__header">
        <span class="wallet-card-shimmer__skeleton wallet-card-shimmer__skeleton--balance" aria-hidden="true"></span>
        <span class="wallet-card-shimmer__skeleton wallet-card-shimmer__skeleton--title" aria-hidden="true"></span>
        <span class="spacer"></span>
        <span class="wallet-card-shimmer__skeleton wallet-card-shimmer__skeleton--icon" aria-hidden="true"></span>
    </div>
    <div class="profile-menu-credits-cards">
        <div class="credits-base-card wallet-card-shimmer__subcard wallet-card-shimmer__skeleton">
        </div>
        <div class="credits-base-card wallet-card-shimmer__subcard wallet-card-shimmer__skeleton">
        </div>
        <div class="credits-base-card wallet-card-shimmer__subcard wallet-card-shimmer__skeleton">
        </div>
    </div>
</div>
